module.exports = __webpack_public_path__ + "img/9881667196346_.pic@2x.e24bbc4e.png";